import React, { useContext, useEffect, useRef, useState } from "react";

import GeofenceForm from "../../Geofences/GeofenceForm/GeofenceForm";
import { popupcontext } from "../../../context/Popupscontext";
import { useGetSpecificGeofenceQuery } from "../../../Redux/service/Geofences/Geofences";
import { EditControl } from "react-leaflet-draw";
import { FeatureGroup } from "react-leaflet";
import { rectangle } from "leaflet";
import usePermission from "../../../hooks/usePermission";

export default function MapFeatures() {
	const [geometry, setGeometry] = useState("");
	const lang = localStorage.getItem("lang") || "en";

	let { handleShowGeo, displayGeo, currentGeofenceId, edited } =
		useContext(popupcontext);
	let { data: EditValues, refetch } = useGetSpecificGeofenceQuery(
		currentGeofenceId,
		{
			skip: !currentGeofenceId,
		}
	);
	const drawnLayerRef = useRef(null);

	useEffect(() => {
		if (edited && currentGeofenceId) {
			refetch();
		}
	}, [edited, currentGeofenceId, refetch]);
	const drawControlOptions = {
		position: lang === "en" ? "topright" : "topleft",
		draw: {
			rectangle: true,
			circle: false,
			polyline: false,
			rectangle: false,
			polygon: displayGeo
				? false
				: {
						allowIntersection: false,
						showArea: true,
						shapeOptions: {
							color: "#22c55e",
							opacity: 1,
							weight: 5,
							fillColor: "#22c55e",
							fillOpacity: 0.2,
						},
				  },
			marker: false,
			circlemarker: false,
		},
		edit: {
			edit: false,
			remove: false,
		},
	};
	const createPolygon = (e) => {
		console.log("e", e);
		const { layerType, layer } = e;
		drawnLayerRef.current = layer;

		if (layerType === "polyline") {
			const latlngs = layer.getLatLngs();
			const lineStringFormat = `LINESTRING (${latlngs
				.map((latlng) => `${latlng.lng} ${latlng.lat}`)
				.join(", ")})`;
			setGeometry(lineStringFormat);
		} else if (layerType === "polygon") {
			const latlngs = layer.getLatLngs()[0];
			const polygonFormat = `POLYGON ((${latlngs
				.map((latlng) => `${latlng.lat} ${latlng.lng}`)
				.join(", ")}))`;
			setGeometry(polygonFormat);
		} else if (layerType === "rectangle") {
			const latlngs = layer.getLatLngs()[0];
			const rectangleFormat = `POLYGON ((${latlngs
				.map((latlng) => `${latlng.lat} ${latlng.lng}`)
				.join(", ")}))`;
			setGeometry(rectangleFormat);
		} else if (layerType === "circle") {
			const center = layer.getLatLng();
			const radius = layer.getRadius();
			const circleFormat = `CIRCLE ((${center.lng} ${center.lat}), RADIUS ${radius})`;
			setGeometry(circleFormat);
		}
		handleShowGeo();
	};
	const handleCancel = React.useCallback(() => {
		if (drawnLayerRef.current) {
			const map = drawnLayerRef.current._map;
			if (!map) return;
			map.removeLayer(drawnLayerRef.current);
			drawnLayerRef.current = null;
		}
		setGeometry(null);
	}, []);
	useEffect(() => {
		if (displayGeo === false) {
			handleCancel();
		}
	}, [displayGeo, handleCancel]);
	const { create, edit } = usePermission("GEOFENCES");

	console.log("Geometry", geometry);
	return (
		<>
			{create && (
				<FeatureGroup>
					<EditControl
						{...drawControlOptions}
						onCreated={createPolygon}
						onEdited={createPolygon}
					/>
				</FeatureGroup>
			)}
			{displayGeo && (create || edit) ? (
				<GeofenceForm area={geometry} Editvalues={EditValues} />
			) : (
				""
			)}
		</>
	);
}
